import { Injectable } from '@angular/core';
import { EventSourceMessage, fetchEventSource } from '@microsoft/fetch-event-source';
import { environment } from '@env/environment';
import { take } from 'rxjs/operators';
// services
import { AuthApiService } from '@app/auth/services';

class RetriableError extends Error {}

@Injectable({
  providedIn: 'root',
})
export class SseService {
  private sseConnected = false;
  private ctrl: AbortController | undefined;

  constructor(private readonly authApiService: AuthApiService) {}

  getSseConnected() {
    return this.sseConnected;
  }
  setSseConnected(connected: boolean) {
    this.sseConnected = connected;
  }

  closeEventSource() {
    if (this.ctrl) {
      this.ctrl.abort();
      this.setSseConnected(false);
      this.ctrl = undefined;
    }
  }

  // using fetch-event-source
  async fetchEventSource(url: string, token: string, onMessage: (ev: EventSourceMessage) => void) {
    // const ctrl = new AbortController();
    this.ctrl = new AbortController();
    return await fetchEventSource(`${environment.apiUrl}${url}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      signal: this.ctrl.signal,
      // The keepalive option can be used to allow the request to outlive the page.
      // keepalive: true,
      openWhenHidden: true,
      onopen: async (res) => {
        if (res.ok && res.status === 200) {
          // console.log('Connection made ', res);
          this.setSseConnected(true);
        } else if (res.status === 401) {
          this.ctrl!.abort('waiting for new access token');
          // refresh token by fetch current user info
          // refresh-token-interceptor will 401 and refresh access token
          this.authApiService.getUserInfo().pipe(take(1)).subscribe();
        } else if (res.status < 500 && res.status !== 429) {
          console.error('Client side error ', res);
        }
      },
      onmessage: onMessage,
      onerror: (error) => {
        console.warn('sse onerror', error);
        this.setSseConnected(false);
        return 2000;
      },
      onclose: () => {
        console.warn('sse onclose');
        this.setSseConnected(false);
        throw new RetriableError('Connection closed');
      },
    });
  }
}
